import React, { useState, useEffect } from "react";
import "./Contact.css";
import { submitFormData } from "../../../src/lib/contactApiConnect";
import ThankYou from "../../components/contact/thankYou/ThankYou";
import { images } from "../../assets";
import { loadGtag } from "../../utility/loadGtag";

function Contact() {

  useEffect(() => {
    loadGtag();
  }, []);
  
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    user_type: "",
    phoneNumber: "",
  });

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    if (!e.target || !e.target.name) {
      return; // Do nothing if target or target name is undefined
    }
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateName = (name) => {
    if (!name || name.length < 2 || /\d/.test(name)) {
      return "Please complete this required field ";
    }
    return "";
  };

  const validateEmail = (email) => {
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      return "Please enter valid email id ";
    }

    return "";
  };

  const validatePhoneNumber = (phoneNumber) => {
    if (!phoneNumber || !/^[0-9]{10}$/.test(phoneNumber)) {
      return "Please enter a valid phone number";
    }
    return "";
  };

  const validateUserType = (user_type) => {
    if (!user_type) {
      return "Please select an option from the dropdown menu";
    }
    return "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formData);
    // Validation
    const nameError = validateName(formData.name);
    const emailError = validateEmail(formData.email);
    const phoneNumberError = validatePhoneNumber(formData.phoneNumber);
    const userTypeError = validateUserType(formData.user_type);

    if (nameError || emailError || phoneNumberError || userTypeError) {
      setErrors({
        name: nameError,
        email: emailError,
        phoneNumber: phoneNumberError,
        user_type: userTypeError,
      });
      return;
    }

    try {
      await submitFormData(formData);
      setFormData({
        name: "",
        email: "",
        message: "",
        user_type: "",
        phoneNumber: "",
      });
      // alert("Your request has been submitted successfully!");
      setSubmitted(true);
    } catch (error) {
      console.error("Error:", error.response ? error.response.data : error.message);
  if (error.response && error.response.data && error.response.data.errors) {
    setErrors(error.response.data.errors);
  } else {
    setErrors({ form: "An unexpected error occurred. Please try again later." });
  }
    }
  };

  if (submitted) {
    return <ThankYou />;
  }

  return (
    <div className="contact">
      <div className="connectUs">
        <div className="connectBox">
          <div className="connectHeading">Connect with us!</div>
          <form onSubmit={handleSubmit} className="connectForm">
            <div className="formRow1">
              <div className="formGroup">
                <label htmlFor="name" className="formLabel">
                  Name<span>*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Enter your full name"
                  required
                  className="formInput"
                  value={formData.name}
                  onChange={handleChange}
                />
                {errors.name && <span className="error">{errors.name}</span>}
              </div>
              <div className="formGroup">
                <label htmlFor="email" className="formLabel">
                  Email ID<span>*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Enter your email id"
                  required
                  className="formInput"
                  value={formData.email}
                  onChange={handleChange}
                />
                {errors.email && <span className="error">{errors.email}</span>}
              </div>
            </div>

            <div className="formGroup">
              <label htmlFor="phoneNumber" className="formLabel">
                Phone Number
              </label>
              <div className="ph">
                <select name="country" className="phformSelect">
                  <option value="INDIA">INDIA</option>
                </select>
                <input
                  type="text"
                  id="phoneNumber"
                  name="phoneNumber"
                  placeholder="Enter mobile number"
                  className="phNoInput"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                />
                {errors.phoneNumber && (
                  <span className="error">{errors.phoneNumber}</span>
                )}
              </div>
            </div>

            <div className="formGroup">
              <label htmlFor="user_type" className="formLabel">
                What can we help you with?<span>*</span>
              </label>
              <select
                id="user_type"
                name="user_type"
                required
                className="formSelect"
                value={formData.user_type}
                onChange={handleChange}
              >
                <option value="">Select </option>
                <option value="corporate">employee health and wellness</option>
                <option value="ngo">ngo fundraise and awareness</option>
                <option value="individual">a job</option>
                <option value="promotion">promote my products</option>
                <option value="csr">showcase my csr</option>
              </select>
              {errors.user_type && (
                <span className="error">{errors.user_type}</span>
              )}
            </div>

            <div className="formGroup">
              <label htmlFor="message" className="formLabel">
                Write to us
              </label>
              <textarea
                id="message"
                name="message"
                placeholder="Message"
                className="formTextarea"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>

            <div className="letsConnect">
              <button type="submit" className="formButton">
                Let's Connect <img src={images.arrowRight} alt="Arrow" />
              </button>
            </div>
          </form>
        </div>
      </div>

      <div className="contactRightpart">
        <img src={images.contactPhoto} alt="contact" />
        <div className="rightpartBox">
          <div className="rightpartText">
            Schedule a live demo with one of our product experts to get your
            queries addressed.
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
